import {HintsActions, IHintsState} from "./types";
import {Reducer} from "redux";
import {getType} from "typesafe-actions";
import * as actions from "./actions";

export const hintsInitialState: IHintsState = {
    activeHints: Object.create(null),
    appliedHints: Object.create(null)
};

export const hintsReducer : Reducer<IHintsState, HintsActions> = (state = hintsInitialState, action) => {
    let index, activeHints, appliedHints;

    switch (action.type) {
        case getType(actions.applyHint.request):
            activeHints = state.activeHints[action.payload.id] || [];

            return {
                ...state,
                activeHints: {
                    [action.payload.id]: [...activeHints, action.payload.hint]
                }
            };

        case getType(actions.applyHint.success):
            appliedHints = state.appliedHints[action.payload.id] || [];
            activeHints = state.activeHints[action.payload.id] || [];
            index = activeHints.indexOf(action.payload.hint);

            return {
                ...state,
                appliedHints: {
                    [action.payload.id]: [...appliedHints, action.payload.hint]
                },
                activeHints: {
                    [action.payload.id]: index > -1
                        ? [...activeHints.slice(0, index), ...activeHints.slice(index + 1)]
                        : state.activeHints[action.payload.id]
                }
            };

        case getType(actions.applyHint.failure):
            activeHints = state.activeHints[action.payload.id] || [];
            index = activeHints.indexOf(action.payload.hint);
            if (index < 0)
                return state;

            return {
                ...state,
                activeHints: {
                    [action.payload.id]: [...activeHints.slice(0, index), ...activeHints.slice(index + 1)]
                }
            };

        default:
            return state;
    }
};
